import React from 'react';
import { useDispatch } from 'react-redux';
import { colors } from "../../../contexts/WorldMapContext/Polyline";
import { selectRoute } from "../../../util/store/selectors";
import { getStore, useSelector } from "../../../util/store/store";
import RouteTable from "../_component/RouteTable";
import { RouteMode } from "../constatns";
import { routeActions } from "../reducer";
import Locations from "./Locations";
import styles from "./style.module.scss";

const CreateButton: React.FC = () => {
    const dispatch = useDispatch()
    const params = useSelector(selectRoute.params);
    const loading = useSelector(selectRoute.loadingRoutes);
    const { source_id = null, destination_id = null } = params || {};

    const handleCreate = () => {
        const { routes } = getStore().route;
        const { source, destination } = params;
        const values = {
            id: '-',
            name: 'New route',
            color: colors[routes.length % 10],
            points: [
                { ...source.position, name: source.name },
                { ...destination.position, name: destination.name }
            ],
            index: routes.length,
            default: Object.keys(routes).length === 0,
            route_mode: 'manual',
        }
        dispatch(routeActions.changeMode({ mode: RouteMode.EDIT, route: values }))
    }

    return <div className={styles.footer}>
        <button {...{
            className: 'bt-primary h-36',
            disabled: !source_id || !destination_id || loading,
            onClick: handleCreate
        }}>
            Create route
        </button>
    </div>
};

interface IProps {
}

const RouteView: React.FC<IProps> = () => {
    return <>
        <div className={styles.title}>Route</div>
        <Locations />
        <CreateButton />
        <RouteTable />
    </>;
};

export default RouteView
